import React from 'react'
import { Checkbox, Flex, Radio, RadioChangeEvent } from 'antd'
import { t } from 'i18next'
import { KpiColumnsShow } from './IndicatorsComparison'

type Channel = {
  name: string,
  id: string,
}

interface SettingsPopupProps {
  channels: Channel[],
  selectedChannelsIds: string[],
  setSelectedChannelsIds: Function,
  kpiColumns?: KpiColumnsShow;
  setKpiColumns?: React.Dispatch<React.SetStateAction<KpiColumnsShow>>,
}

const allProductsPath = '/reports/all'
const indicatorsComparisonPath = '/reports/indicators-comparison'

export default function SettingsPopup ({
  channels, selectedChannelsIds, setSelectedChannelsIds, kpiColumns,
  setKpiColumns,
}: SettingsPopupProps) {
  const selectAll = () => {
    setSelectedChannelsIds([
      ...channels.map((channel: Channel) => channel.id)
    ])
  }

  const isAllChannelsSelected = () => {
    return channels.every((channel: Channel) => selectedChannelsIds.includes(channel.id))
  }

  const isSomeChannelsSelected = () => {
    return !isAllChannelsSelected() && channels.some((channel: Channel) => selectedChannelsIds.includes(channel.id))
  }

  const onDeselectAll = () => {
    setSelectedChannelsIds([])
  }

  const onKpiSettingsChange = (e: RadioChangeEvent) => {
    setKpiColumns && setKpiColumns(e.target.value);
  };

  return (
    <>
      <Flex className={'settings-popover__title'}>{t('reports.setView')}</Flex>
      <Flex vertical gap={6} justify={'center'}>
        {kpiColumns &&
          <Flex className={'settings-popover__block'} vertical gap={2} justify={'center'} style={{padding: '12px 8px'}}>
            <Radio.Group
              onChange={onKpiSettingsChange}
              value={kpiColumns}
              options={[
                {
                  value: 'kpi',
                  label: (
                    <Flex gap="small" justify="center" align="center" vertical>
                      {t('planner.kpiInTotals')}
                    </Flex>
                  ),
                },
                {
                  value: 'all',
                  label: (
                    <Flex gap="small" justify="center" align="center" vertical>
                      {t('planner.kpiAll')}
                    </Flex>
                  ),
                },
              ]}
            />
          </Flex>
        }

        <Flex className={'settings-popover__block'} vertical gap={'small'} justify={'center'}>
          <Flex className={'settings-popover__items-title'} gap={'small'} justify={'space-between'}>
            <Flex gap={'small'} align={'center'}>
              <Checkbox
                indeterminate={isSomeChannelsSelected()}
                onChange={onDeselectAll}
                checked={isAllChannelsSelected()}
              ></Checkbox>
              {t('planner.channels')}
            </Flex>
            <Flex className={'settings-popover__items-title-count'} gap={'small'}>
              {selectedChannelsIds.length}
            </Flex>
          </Flex>
          <Flex className={'settings-popover__select-all'} onClick={() => selectAll()}>
            {t('reports.selectAll')}
          </Flex>
          <Flex vertical gap={2} className={'settings-popover__items'}>
            {channels.map((channel: Channel) => (
              <Flex className={'settings-popover__item'} gap={'small'} key={channel.id}>
                <Checkbox
                  checked={selectedChannelsIds.includes(channel.id)}
                  onChange={(event) => {
                    if (event.target.checked) {
                      setSelectedChannelsIds([
                        ...selectedChannelsIds,
                        channel.id,
                      ])
                    } else {
                      setSelectedChannelsIds([...selectedChannelsIds.filter(function (value) {
                        return value !== channel.id
                      })])
                    }
                  }}
                />
                {channel.name}
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
